import { render, staticRenderFns } from "./MainText.vue?vue&type=template&id=74ec73cd&scoped=true&"
import script from "./MainText.vue?vue&type=script&lang=js&"
export * from "./MainText.vue?vue&type=script&lang=js&"
import style0 from "./MainText.vue?vue&type=style&index=0&id=74ec73cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec73cd",
  null
  
)

export default component.exports